import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icon-v2/icon.component";
import * as i3 from "@ngx-translate/core";
const _c0 = [[["", "side-modal-header", ""]], [["", "side-modal-sub-header", ""]], [["", "side-modal-body", ""]], [["", "side-modal-footer", ""]]];
const _c1 = ["[side-modal-header]", "[side-modal-sub-header]", "[side-modal-body]", "[side-modal-footer]"];
const _c2 = a0 => ({
  "gea-side-modal-footer-border": a0
});
function SideModalV2Component_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function SideModalV2Component_div_7_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeSideModal.emit());
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("clickable", true)("color", "black")("file", "16px_close");
  }
}
export class SideModalV2Component {
  show = false;
  modalTitle = '';
  showCloseIcon = true;
  showFooterBorder = false;
  openSideModal = new EventEmitter();
  closeSideModal = new EventEmitter();
  static ɵfac = function SideModalV2Component_Factory(t) {
    return new (t || SideModalV2Component)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SideModalV2Component,
    selectors: [["geaui-side-modal-v2"]],
    inputs: {
      show: "show",
      modalTitle: "modalTitle",
      showCloseIcon: "showCloseIcon",
      showFooterBorder: "showFooterBorder"
    },
    outputs: {
      openSideModal: "openSideModal",
      closeSideModal: "closeSideModal"
    },
    ngContentSelectors: _c1,
    decls: 14,
    vars: 10,
    consts: [[1, "gea-side-modal-container"], [1, "gea-side-modal-header", "gea-font-heading-20"], ["data-cy", "title"], ["class", "gea-side-modal-close-icon", 3, "click", 4, "ngIf"], ["data-cy", "sub-title", 1, "gea-font-heading-14", "gea-side-modal-sub-header"], ["data-cy", "side-modal-body", 1, "gea-side-modal-body"], ["data-cy", "side-modal-footer", 1, "gea-side-modal-footer", 3, "ngClass"], [1, "gea-side-modal-close-icon", 3, "click"], [3, "clickable", "color", "file"]],
    template: function SideModalV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "section", 0)(1, "header")(2, "div", 1)(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, SideModalV2Component_div_7_Template, 2, 3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵprojection(9, 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵprojection(11, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵprojection(13, 3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("side-modal-container-open", ctx.show);
        i0.ɵɵattribute("data-cy", ctx.show ? "side-modal-container-open" : "side-modal-container-closed");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, ctx.modalTitle));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showCloseIcon);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, ctx.showFooterBorder));
      }
    },
    dependencies: [i1.NgClass, i1.NgIf, i2.IconComponent, i3.TranslatePipe],
    styles: [".gea-side-modal-container[_ngcontent-%COMP%]{font-family:GEA Inter,GEA Sans,sans-serif;position:absolute;font-size:16px;width:420px;height:100%;z-index:5;background:var(--geaui-pure-white);right:0;top:0;transform:translate(420px);min-height:74px;border:0 none;box-shadow:0 0 14px #0000001a;display:none}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;align-self:start;width:100%;position:relative;height:72px}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:var(--geaui-pure-black);padding:24px 16px 24px 24px;display:flex;align-items:center;gap:16px}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-header[_ngcontent-%COMP%]   .gea-side-modal-close-icon[_ngcontent-%COMP%]{cursor:pointer;margin-right:32px}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-sub-header[_ngcontent-%COMP%]{align-self:start;overflow-y:auto;padding:0 24px;width:100%;border-bottom:2px solid var(--geaui-grey-05)}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-body[_ngcontent-%COMP%]{padding:0 24px;height:100%;overflow-y:auto}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-footer[_ngcontent-%COMP%]{padding:24px}.gea-side-modal-container[_ngcontent-%COMP%]   .gea-side-modal-footer-border[_ngcontent-%COMP%]{border-top:2px solid var(--geaui-grey-05)}.side-modal-container-open[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_slideIn .3s ease;transform:translate(0);display:flex;flex-direction:column}@keyframes _ngcontent-%COMP%_slideIn{0%{transform:translate(420px)}to{transform:translate(0)}}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SideModalV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-side-modal-v2',
      template: "<section\n  class=\"gea-side-modal-container\"\n  [class.side-modal-container-open]=\"show\"\n  [attr.data-cy]=\"show ? 'side-modal-container-open' : 'side-modal-container-closed'\">\n  <header>\n    <div class=\"gea-side-modal-header gea-font-heading-20\">\n      <span data-cy=\"title\">{{ modalTitle | translate }}<ng-content select=\"[side-modal-header]\"></ng-content></span>\n      <div class=\"gea-side-modal-close-icon\" *ngIf=\"showCloseIcon\" (click)=\"closeSideModal.emit()\">\n        <geaui-icon-v2 [clickable]=\"true\" [color]=\"'black'\" [file]=\"'16px_close'\"> </geaui-icon-v2>\n      </div>\n    </div>\n    <div class=\"gea-font-heading-14 gea-side-modal-sub-header\" data-cy=\"sub-title\">\n      <ng-content select=\"[side-modal-sub-header]\"></ng-content>\n    </div>\n  </header>\n  <div class=\"gea-side-modal-body\" data-cy=\"side-modal-body\">\n    <ng-content select=\"[side-modal-body]\"></ng-content>\n  </div>\n  <div class=\"gea-side-modal-footer\" [ngClass]=\"{ 'gea-side-modal-footer-border': showFooterBorder }\" data-cy=\"side-modal-footer\">\n    <ng-content select=\"[side-modal-footer]\"></ng-content>\n  </div>\n</section>\n",
      styles: [".gea-side-modal-container{font-family:GEA Inter,GEA Sans,sans-serif;position:absolute;font-size:16px;width:420px;height:100%;z-index:5;background:var(--geaui-pure-white);right:0;top:0;transform:translate(420px);min-height:74px;border:0 none;box-shadow:0 0 14px #0000001a;display:none}.gea-side-modal-container .gea-side-modal-header{display:flex;justify-content:space-between;align-items:center;align-self:start;width:100%;position:relative;height:72px}.gea-side-modal-container .gea-side-modal-header span{color:var(--geaui-pure-black);padding:24px 16px 24px 24px;display:flex;align-items:center;gap:16px}.gea-side-modal-container .gea-side-modal-header .gea-side-modal-close-icon{cursor:pointer;margin-right:32px}.gea-side-modal-container .gea-side-modal-sub-header{align-self:start;overflow-y:auto;padding:0 24px;width:100%;border-bottom:2px solid var(--geaui-grey-05)}.gea-side-modal-container .gea-side-modal-body{padding:0 24px;height:100%;overflow-y:auto}.gea-side-modal-container .gea-side-modal-footer{padding:24px}.gea-side-modal-container .gea-side-modal-footer-border{border-top:2px solid var(--geaui-grey-05)}.side-modal-container-open{animation:slideIn .3s ease;transform:translate(0);display:flex;flex-direction:column}@keyframes slideIn{0%{transform:translate(420px)}to{transform:translate(0)}}\n"]
    }]
  }], null, {
    show: [{
      type: Input
    }],
    modalTitle: [{
      type: Input
    }],
    showCloseIcon: [{
      type: Input
    }],
    showFooterBorder: [{
      type: Input
    }],
    openSideModal: [{
      type: Output
    }],
    closeSideModal: [{
      type: Output
    }]
  });
})();
